import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const UnitService = {
  getList: async ({ pageNumber, pageSize }) => {
    const response = await apiService.get(`/${slug}/menuitemunit/getlist?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    return response.data;
  },
  create: async (data) => {
    const response = await apiService.post(
      `/${slug}/menuitemunit/create`,
      data
    );
    return response.data;
  },
  update: async (id, data) => {
    const response = await apiService.patch(
      `/${slug}/menuitemunit/update?id=${id}`,
      data
    );
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(
      `/${slug}/menuitemunit/delete?id=${id}`
    );
    return response.data;
  },
  detail: async (id) => {
    const response = await apiService.get(
      `/${slug}/menuitemunit/getdetail?id=${id}`
    );
    return response.data;
  },
};

export default UnitService;
